module.exports = __webpack_public_path__ + "img/estatusAprobado.09e5587e.png";